import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { EntityPage } from '@/shared/models/entity-page';

import { IJourney } from '../model/journey';
import { namespace as journeyNamespace } from '../namespace';

interface TState {
  journey: IJourney | null;
  journeys: EntityPage<IJourney>;
}

const initialState: TState = {
  journey: null,
  journeys: {
    items: [],
    total: 0,
    limit: 10,
    offset: 0,
  },
};

const journeysSlice = createSlice({
  name: journeyNamespace,
  initialState,
  reducers: {
    setJourneys: (state, action: PayloadAction<EntityPage<IJourney>>) => {
      state.journeys = action.payload;
    },
    setJourney: (state, action: PayloadAction<IJourney>) => {
      state.journey = action.payload;
    },
  },
});

export { journeysSlice, journeyNamespace };
